module.exports = __webpack_public_path__ + "static/media/TradeGothic.21523f17.woff2";